import { API_ROOT } from '../constants/api';

// Reservations
export const reservationsEndpoint = () => `${API_ROOT}/reservations`;
export const reservationEndpoint = (resId) => `${API_ROOT}/reservations/${resId}`;

// Facilities
export const facilitiesEndpoint = () => `${API_ROOT}/facilities`;

// Pass Types
export const passTypesByFacilityEndpoint = (facilityId) => `${API_ROOT}/passtypes/facility/${facilityId}`;
export const passTypeEndpoint = (passTypeId) => `${API_ROOT}/passtypes/${passTypeId}`;
